import React from "react";
import FormControl from "@mui/material/FormControl";
import { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { StyledMenuItem, StyledSelect } from "./style";

export type SelectOption = {
  value: string | number;
  label: string;
};

interface ISelect {
  onChange: (newValue: string | number) => void;
  options: SelectOption[];
  selectedValue?: string;
  fontColor?: string; // Nova propriedade adicionada
}

export const Select: React.FC<ISelect> = ({
  onChange,
  options,
  selectedValue = "",
  fontColor = "white", // Valor padrão definido como 'white'
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <StyledSelect
        value={selectedValue}
        // eslint-disable-next-line
        //@ts-ignore 
        onChange={handleChange}
        displayEmpty
        fontColor={fontColor} // Passando fontColor para StyledSelect
      >
        <MenuItem value="" disabled>
          <em>...</em>
        </MenuItem>
        {options.map((option, index) => (
          <StyledMenuItem
            key={option.value}
            value={option.value}
            isFirst={index === 0}
            isLast={index === options.length - 1}
            fontColor={fontColor} // Passando fontColor para StyledMenuItem
          >
            {option.label}
          </StyledMenuItem>
        ))}
      </StyledSelect>
    </FormControl>
  );
};
